import * as React from "react";

import { Button, Msg, Portal } from "@shared/components";

import SubmitExam from "../../../modals/submitExam/SubmitExam.connect";

/**
 * Prop interface
 */
export interface SubmitExamPanelProps {
  submitExam: () => void;
}

/**
 * State interface
 */
export interface SubmitExamPanelState {
  isOpenSubmitExam: boolean;
}

/**
 * Page component
 */
class SubmitExamPanel extends React.Component<
  SubmitExamPanelProps,
  SubmitExamPanelState
> {
  constructor(props: SubmitExamPanelProps) {
    super(props);

    this.state = {
      isOpenSubmitExam: false,
    };
  }

  public render() {
    return (
      <>
        <div className="submit-exam-panel">
          <p>
            <strong>
              <Msg id={"editor-exam-submit.areYouSure1"} />
            </strong>
          </p>
          <Button
            type="warning"
            onClick={this.onOpenExamSubmit}
            ariaLabel="Submit Exam"
          >
            <Msg id="button.submitExam" />
          </Button>
        </div>
        {this.state.isOpenSubmitExam && (
          <Portal>
            <SubmitExam
              isOpen={this.state.isOpenSubmitExam}
              onCancel={this.onCloseModal}
              onSubmit={this.onExamSubmit}
            />
          </Portal>
        )}
      </>
    );
  }

  private onOpenExamSubmit = () => {
    this.setState({ isOpenSubmitExam: true });
  };

  private onExamSubmit = () => {
    this.props.submitExam();
    this.onCloseModal();
  };

  private onCloseModal = () => {
    this.setState({ isOpenSubmitExam: false });
  };
}

export default SubmitExamPanel;
